/**
 * 一键标记富文本中的数字颜色
 * @param {*} editorData
 * @returns
 */
export function markEditorNumberColor(editorData, color) {
  const data = editorData.data || [];
  function markColor(data = []) {
    let list = [];
    data.forEach(item => {
      // eslint-disable-next-line
      if (!item.type && item.hasOwnProperty("text")) {
        const text = item.text;
        const regx = /[0-9-+%.]+/g;
        const noNumberList = text.split(regx);
        const markNumberList = text.match(regx) || [];
        const markList = [];
        noNumberList.forEach((text, index) => {
          markList.push({
            ...item,
            text
          });
          if (markNumberList[index]) {
            const obj = {
              ...item,
              text: markNumberList[index],
              color: color
            };
            if (!color) {
              delete obj.color;
            }
            markList.push(obj);
          }
        });
        list = list.concat(markList);
      } else if (item.children && item.children.length > 0) {
        const children = markColor(item.children);
        item.children = children;
        list.push(item);
      } else {
        list.push(item);
      }
    });

    return list;
  }
  let markData = markColor(data);
  return {
    type: "simpleEditor",
    data: markData
  };
}
